import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-31712cd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "h1"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "preamble"
}
const _hoisted_8 = {
  key: 2,
  class: "itemContainer"
}
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 4,
  class: "address"
}
const _hoisted_12 = { class: "h4" }
const _hoisted_13 = {
  key: 5,
  class: "ctaLink rte"
}
const _hoisted_14 = ["href"]

import { Skeletor } from 'vue-skeletor';
import { Icon, RoutesServed } from '@components';
import { InteractiveMapPanelViewModel } from '@components/types/RenderTypes';
import 'vue-skeletor/dist/vue-skeletor.css';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PanelViewModal',
  props: {
    viewModal: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const audioElement = ref<HTMLAudioElement | null>(null);



const toggleAudio = () => {
  const audioSound = audioElement.value;
  if (audioSound) {
    if (audioSound.paused) {
      audioSound.play();
    } else {
      audioSound.pause();
    }
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.viewModal.title), 1))
          : (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_unref(Skeletor), {
                key: 1,
                shimmer: true,
                class: "titleSkeleton"
              }))
            : _createCommentVNode("", true),
        (_ctx.viewModal.soundbiteUrl && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "audioIcon",
              "aria-label": _ctx.$t('Audio button aria label'),
              onClick: toggleAudio
            }, [
              _createVNode(_unref(Icon), { "icon-name": "audio" }),
              _createElementVNode("audio", {
                ref_key: "audioElement",
                ref: audioElement,
                src: _ctx.viewModal.soundbiteUrl
              }, null, 8, _hoisted_6)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.viewModal.description), 1))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), {
              key: 1,
              class: "preambleSkeleton"
            }))
          : _createCommentVNode("", true),
      (_ctx.viewModal.activities && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewModal.activities, (activity, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: activity.icon,
                    alt: ""
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("p", null, _toDisplayString(activity.description), 1)
              ]))
            }), 128))
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), {
              key: 3,
              class: "activitiesSkeleton"
            }))
          : _createCommentVNode("", true),
      (_ctx.viewModal.address && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.viewModal.addressTitle), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.viewModal.address), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
            _createElementVNode("a", {
              href: _ctx.viewModal.linkUrl
            }, _toDisplayString(_ctx.viewModal.linkText), 9, _hoisted_14)
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), {
              key: 6,
              class: "linkSkeleton"
            }))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(RoutesServed), {
      routes: _ctx.viewModal.routesServed,
      "is-loading": _ctx.isLoading,
      "is-interactive-map-view": true
    }, null, 8, ["routes", "is-loading"])
  ]))
}
}

})